import { useState, useEffect, useMemo } from "react";
import tw from "tailwind-styled-components";
import {
  BoxContainer,
  Underline,
  BoxTitle,
  BoxHead,
  FilterTableWrapper,
  FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import { Form, Formik } from "formik";
import Table from "../../Components/Properties/Table";
import SearchFilterBox from "../../Components/SearchFilterBox";
import SideModal from "../../Components/SideModal";
import AddPropertyPage from "../../Components/AddBrokerProperty/AddPropertyPage";
import AddDeal from "../../Components/Properties/AddDeal";
import InventoryFilterModal from "../../Components/Properties/InventoryFilterModal";
import ViewDealsModal from "../../Components/Properties/ViewDealsModal";
import ViewTenantModal from "../../Components/Properties/ViewTenantModal";
import LinkStaff from "../../Components/Properties/LinkStaff";
import AddTenant from "../../Components/Properties/AddTenant";
import axios from "axios";
import Config from "../../Config";
import { toast } from "react-toastify";
import { useMutation } from "react-query";
import NotFoundModel from "../../Components/NotFoundModel";
import Loading from "../../Components/Loading";
import useDeal from "../../utilities/addDeal.api";
import MatchingEnquiries from "../../Components/Properties/MatchingEnquiries";
import { AddBtn } from "../../Components/Styles/InputStyles";

const InventoryList = () => {
  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const searchOptions = [{ label: "Name", value: 1 }];
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState("");
  const [selectedDeal, setSelectedDeal] = useState("");
  const [selectedInventory, setSelectedInventory] = useState("");
  const [selectedTableRow, setSelectedTableRow] = useState("");
  const [summaryData, setSummaryData] = useState(null);
  const [selectedTab, setSelectedTab] = useState(1);
  const [apiData, setApiData] = useState(null);
  const [isAddProperty, setIsAddProperty] = useState(false);
  const [isAddDeal, setIsAddDeal] = useState(false);
  const [isAddTenant, setIsAddTenant] = useState(false);
  const [showLinkStaffModel, setShowLinkStaffModel] = useState(false);
  const [step, setStep] = useState(1);
  const [showViewDeals, setShowViewDeals] = useState(false);
  const [showTenantDetails, setShowTenantDetails] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterType, setFilterType] = useState("");
  const [dealList, setDealList] = useState([]);
  const [staffList, setStaffList] = useState();
  const [activeTab, setActiveTab] = useState("1");
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [tenantData, setTenantData] = useState(null);
  const [enquiryList, setEnquiryList] = useState([]);
  const [isMatchDrawerOpen, setIsMatchDrawerOpen] = useState(false);

  const fetchInventoryList = async (params) => {
    const query = `&s=${params.searchQuery || ""}&t=${params.filterType || ""}`;

    const response = await axios.get(
      `${Config.apiUrl}/inventory/list?${query}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );

    return response.data;
  };

  const getInventorySuccess = (res) => {
    if (res?.isSuccess) {
      setApiData(res?.data || []);
      setFilteredData(res?.data || []);
      setSummaryData(res?.summary || null);
      setStaffList(res?.staffList || []);
    }
  };

  const getInventoryError = (err) => {
    toast.error(err?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading,
    mutate: getInventoryMutate,
    error,
    isRefetching,
    data,
  } = useMutation(fetchInventoryList, {
    onSuccess: getInventorySuccess,
    onError: getInventoryError,
  });

  useEffect(() => {
    handleClearFilter();
  }, []);

  //------- Add Deal details -------
  const { addDealMutate, addDealLoading } = useDeal({
    token: user.token,
    onSuccessCallback: () => {
      setIsAddDeal(false);
      setIsMatchDrawerOpen(false);
      getDealListMutate(selectedInventory?.id);
      getInventoryMutate({ searchQuery, filterType });

    },
  });

  // ------- Update Inventory Status -------
  const updateStatusFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/inventory/update/status`,
      values,
      {
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${user.token}`,
        },
      },
    );
  };

  const updateStatusSuccess = (data) => {
    toast.success(data?.data?.msg || "Status updated");
    getInventoryMutate({ searchQuery, filterType });
  };

  const updateStatusError = (err) => {
    toast.error(err?.response?.data?.msg || "Error updating status");
  };

  const { mutate: updateStatusMutate } = useMutation(updateStatusFunction, {
    onSuccess: updateStatusSuccess,
    onError: updateStatusError,
  });

  // ------- Get Deal List By Inventory Id -------
  const getDealListFunction = async (inventoryId) => {
    const response = await axios.get(
      `${Config.apiUrl}/deal/list?inventoryId=${inventoryId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  };

  const getDealListSuccess = (res) => {
    if (res?.isSuccess) {
      setDealList(res?.data || []);
      setShowViewDeals(true);
    }
  };

  const getDealListError = (err) => {
    toast.error(err?.response?.data?.msg || "Error fetching deals");
  };

  const { mutate: getDealListMutate, isLoading: dealLoading } = useMutation(
    getDealListFunction,
    {
      onSuccess: getDealListSuccess,
      onError: getDealListError,
    },
  );

  // ------- Get Tenant List By Inventory Id -------
  const getTenantListFunction = async (inventoryId) => {
    const response = await axios.get(
      `${Config.apiUrl}/tenant/list?inventoryId=${inventoryId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  };

  const getTenantListSuccess = (res) => {
    if (res?.isSuccess) {
      const tenantData = res?.data;
      setTenantData(Array.isArray(tenantData) ? tenantData : [tenantData]);
      setShowTenantDetails(true);
    }
  };

  const getTenantListError = (err) => {
    toast.error(err?.response?.data?.msg || "Error fetching deals");
  };

  const { mutate: getTenantListMutate, isLoading: tenantLoading } = useMutation(
    getTenantListFunction,
    {
      onSuccess: getTenantListSuccess,
      onError: getTenantListError,
    },
  );

  //------- Add Assigned Staff details -------
  const addAssignedStaffFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/deal/assign/staff`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addAssignedStaffSuccess = (data) => {
    setShowLinkStaffModel(false);
    getDealListMutate(selectedInventory.id);
    toast.success(data?.data?.msg || "Success");
  };

  const addAssignedStaffError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addAssignedStaffLoading, mutate: addAssignedStaffMutate } =
    useMutation(addAssignedStaffFunction, {
      onSuccess: addAssignedStaffSuccess,
      onError: addAssignedStaffError,
    });

  // ------- Get Unassigned Staff By Inventory Id -------
  const getUnassinedStaffFunction = async (dealId) => {
    const response = await axios.get(
      `${Config.apiUrl}/deal/unassigned/staffs?dealId=${dealId}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  };

  const getUnassinedStaffSuccess = (res) => {
    if (res?.isSuccess) {
      setStaffList(res?.data || []);
      setShowLinkStaffModel(true);
    }
  };

  const getUnassinedStaffError = (err) => {
    toast.error(err?.response?.data?.msg || "Error fetching deals");
  };
  const { mutate: getUnassinedStaffMutate, isLoading: unassinedStaffLoading } =
    useMutation(getUnassinedStaffFunction, {
      onSuccess: getUnassinedStaffSuccess,
      onError: getUnassinedStaffError,
    });

  //----fetch enquiry matching with the inventory-------
  const fetchMatchingEnquiries = async (params) => {
    let url = `${Config.apiUrl}/enquiry/${params.id}/matching`;

    const response = await axios.get(url, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });

    return response.data;
  };

  const getMatchingSuccess = (res) => {
    if (res.isSuccess === false) {
      toast.error(res.msg || "Failed to fetch inventories");
    } else {
      //const filteredData = res?.data.filter(item => item.dealCount === 0);
      setEnquiryList(res?.data || []);
    }
  };

  const getMatchingError = (err) => {
    toast.error("Something went wrong");
  };

  const { isLoading: enquiryLoading, mutate: getEnquiryListMutate } =
    useMutation(fetchMatchingEnquiries, {
      onSuccess: getMatchingSuccess,
      onError: getMatchingError,
    });

  //------- Add Tenant details -------
  const addTenantFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/tenant/add`, values, {
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${user.token}`,
      },
    });
  };

  const addTenantSuccess = (data) => {
    setIsAddTenant(false);
    getInventoryMutate({ searchQuery, filterType });
    toast.success(data?.data?.msg || "Success");
  };

  const addTenantError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addTenantLoading, mutate: addTenantMutate } = useMutation(
    addTenantFunction,
    {
      onSuccess: addTenantSuccess,
      onError: addTenantError,
    },
  );

  const handleAssignStaff = (deal) => {
    setSelectedData(deal);
    setSelectedDeal(deal);
    getUnassinedStaffMutate(deal.id);
  };

  const tabStatusMap = {
    1: Config.INVENTORY_STATUS.AVAILABLE,
    2: Config.INVENTORY_STATUS.BOOKED,
    3: Config.INVENTORY_STATUS.LEASED,
    4: Config.INVENTORY_STATUS.HOLD,
    5: Config.INVENTORY_STATUS.UNVERIFIED,
  };

  useEffect(() => {
    if (!apiData || isFilterApplied) return;

    const status = tabStatusMap[activeTab];

    const filtered = status
      ? apiData.filter((item) => item.status === status)
      : apiData;

    setFilteredData(filtered);
  }, [activeTab, apiData, isFilterApplied]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSelectedTab(tab);
    if (isFilterApplied) {
      setIsFilterApplied(false);
      setActiveFilter(null);
    }
  };

  const summaryCounts = useMemo(() => {
    if (!apiData) {
      return {
        available: 0,
        closed: 0,
        leased: 0,
        hold: 0,
        unverified:0,
      };
    }

    return {
      available: apiData.filter(
        (item) => item.status === Config.INVENTORY_STATUS.AVAILABLE,
      ).length,
      closed: apiData.filter(
        (item) => item.status === Config.INVENTORY_STATUS.BOOKED,
      ).length,
      leased: apiData.filter(
        (item) => item.status === Config.INVENTORY_STATUS.LEASED,
      ).length,
      hold: apiData.filter(
        (item) => item.status === Config.INVENTORY_STATUS.HOLD,
      ).length,
      unverified: apiData.filter(
        (item) => item.status === Config.INVENTORY_STATUS.UNVERIFIED,
      ).length,
    };
  }, [apiData]);

  const handleFilterChange = (values) => {
    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);

    getInventoryMutate({
      searchQuery: values.searchQuery,
      filterType: values.filterType,
    });
  };

  const handleClearFilter = () => {
    setFilterType("");
    setSearchQuery("");

    getInventoryMutate({
      searchQuery: "",
      filterType: "",
    });
  };

  const handleDealClose = () => {
    setIsAddDeal(false);
    setSelectedTableRow("");
  };

  const handleAddTenantClose = () => {
    setIsAddTenant(false);
  };
  const handleApplyFilter = (filterValue, filterLabel, filterType) => {
    if (!apiData) return;

    let filtered = [...apiData];

    if (filterType === "Status") {
      filtered = apiData.filter(
        (item) => item.availabilityStatus === filterLabel.toLowerCase(),
      );
    } else if (filterType === "Property Type") {
      filtered = apiData.filter(
        (item) => item.propertyType === filterLabel.toLowerCase(),
      );
    } else if (filterType === "Locality") {
      const locationId = parseInt(filterValue.replace("LOC_", ""));
      filtered = apiData.filter((item) => item.locationId === locationId);
    }

    setFilteredData(filtered);
    setActiveFilter({
      value: filterValue,
      label: filterLabel,
      type: filterType,
    });
    setIsFilterOpen(false);
  };

  const handleClearFilters = () => {
    setFilteredData(apiData);
    setActiveFilter(null);
  };

  const handleCloseViewDeals = () => {
    setShowViewDeals(false);
  };

  const handleCloseLinkStaff = () => {
    setShowLinkStaffModel(false);
  };

  return (
    <>
      <BoxContainer>
        <BoxHead>
          <BoxTitle className="!mb-0 whitespace-nowrap">
            Inventory
            <Underline />
          </BoxTitle>
          <Filters setIsAddProperty={setIsAddProperty} />
        </BoxHead>
        <SideModal isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)}>
          <InventoryFilterModal
            onApplyFilter={handleApplyFilter}
            handleClose={() => setIsFilterOpen(false)}
            currentFilter={activeFilter}
            handleClearFilters={handleClearFilters}
          />
        </SideModal>

        <SideModal isOpen={showViewDeals} onClose={handleCloseViewDeals}>
          <ViewDealsModal
            apiData={dealList}
            handleClose={handleCloseViewDeals}
            selectedData={selectedInventory}
            handleAssignStaff={handleAssignStaff}
            setIsAddDeal={setIsAddDeal}
          />
        </SideModal>

        <SideModal
          isOpen={showTenantDetails}
          onClose={() => setShowTenantDetails(false)}
        >
          <ViewTenantModal
            apiData={tenantData}
            handleClose={() => setShowTenantDetails(false)}
            selectedData={selectedInventory}
            setIsAddTenant={setIsAddTenant}
          />
        </SideModal>

        <SideModal
          isOpen={showLinkStaffModel}
          onClose={handleCloseLinkStaff}
          width="1/3"
          level="high"
        >
          <LinkStaff
            handleClose={handleCloseLinkStaff}
            selectedData={selectedDeal}
            addAssignedStaffLoading={addAssignedStaffLoading}
            addAssignedStaffMutate={addAssignedStaffMutate}
            staffList={staffList}
          />
        </SideModal>

        <SideModal
          isOpen={isAddProperty}
          onClose={() => {
            setIsAddProperty(false);
            setStep(1);
          }}
        >
          <AddPropertyPage
            setIsAddProperty={setIsAddProperty}
            isAddProperty={isAddProperty}
            step={step}
            setStep={setStep}
            user={user}
            getListMutate={getInventoryMutate}
          />
        </SideModal>

        <SideModal
          isOpen={isAddDeal}
          onClose={() => {
            setIsAddDeal(false);
            setSelectedTableRow("");
          }}
          width="1/3"
          level="high"
        >
          <AddDeal
            setIsAddDeal={setIsAddDeal}
            isAddDeal={isAddDeal}
            handleClose={handleDealClose}
            selectedData={selectedInventory}
            addDealLoading={addDealLoading}
            addDealMutate={addDealMutate}
            selectedTableRow={selectedTableRow}
          />
        </SideModal>

        <SideModal
          isOpen={isAddTenant}
          onClose={() => {
            setIsAddTenant(false);
          }}
          width="1/3"
          level="high"
        >
          <AddTenant
            handleClose={handleAddTenantClose}
            selectedData={selectedInventory}
            addTenantLoading={addTenantLoading}
            addTenantMutate={addTenantMutate}
          />
        </SideModal>

        <SideModal
          isOpen={isMatchDrawerOpen}
          onClose={() => setIsMatchDrawerOpen(false)}
        >
          <MatchingEnquiries
            apiData={enquiryList}
            loading={enquiryLoading}
            handleClose={() => setIsMatchDrawerOpen(false)}
            setIsAddDeal={setIsAddDeal}
            setSelectedTableRow={setSelectedTableRow}
          />
        </SideModal>

        <FloorTabs>
          <FloorTab
            onClick={() => handleTabChange("1")}
            $active={activeTab === "1" && !isFilterApplied}
          >
            Available ({summaryCounts.available})
          </FloorTab>

          <FloorTab
            onClick={() => handleTabChange("2")}
            $active={activeTab === "2" && !isFilterApplied}
          >
            Booked ({summaryCounts.closed})
          </FloorTab>

          <FloorTab
            onClick={() => handleTabChange("3")}
            $active={activeTab === "3" && !isFilterApplied}
          >
            Leased ({summaryCounts.leased})
          </FloorTab>

          <FloorTab
            onClick={() => handleTabChange("4")}
            $active={activeTab === "4" && !isFilterApplied}
          >
            Hold ({summaryCounts.hold})
          </FloorTab>

          <FloorTab
            onClick={() => handleTabChange("5")}
            $active={activeTab === "5" && !isFilterApplied}
          >
            Unverified ({summaryCounts.unverified})
          </FloorTab>
        </FloorTabs>

        <FilterTableWrapper>
          <FilterWrapper>
            <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
              <SearchFilterBox
                options={searchOptions}
                handleFilterChange={handleFilterChange}
                handleClearFilters={handleClearFilter}
              />
            </div>

            <div className="flex gap-2 justify-end items-center"></div>
          </FilterWrapper>

          {!error && !isLoading && apiData && (
            <TableWrapper>
              {/* <PropertyList */}
              <Table
                apiData={filteredData}
                setSelectedInventory={setSelectedInventory}
                selectedInventory={selectedInventory}
                setSelectedData={setSelectedData}
                // setViewDetail={setViewDetail}
                setIsAddDeal={setIsAddDeal}
                setIsAddTenant={setIsAddTenant}
                setShowViewDeals={setShowViewDeals}
                updateStatusMutate={updateStatusMutate}
                getDealListMutate={getDealListMutate}
                getTenantListMutate={getTenantListMutate}
                getEnquiryListMutate={getEnquiryListMutate}
                setEnquiryList={setEnquiryList}
                setIsMatchDrawerOpen={setIsMatchDrawerOpen}
                dealLoading={dealLoading}
                selectedTab={Number(selectedTab)}
              />
              {(!filteredData || filteredData.length === 0) && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
        </FilterTableWrapper>
        {error && !isLoading && <NotFoundModel />}
        {(isLoading || isRefetching) && <Loading />}
      </BoxContainer>
    </>
  );
};

const Filters = ({ setIsAddProperty }) => {
  return (
    <Formik>
      <Form>
        <FilterContainer>
          <AddBtn
            type="button"
            onClick={() => {
              setIsAddProperty(true);
            }}
          >
            {"Add Inventory"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`mt-4 bg-white rounded-md`;
const FloorTabs = tw.div`flex overflow-x-auto bg-white rounded-md my-4 border-b`;

const FloorTab = tw.button`
  ${(p) =>
    p.$active
      ? " text-primary-color border-b-2 border-b-primary-color bg-cyan-50 "
      : " text-gray-700 "} 
  px-5 py-3 cursor-pointer font-medium transition-all duration-200 whitespace-nowrap text-sm
`;
    const FilterContainer = tw.div`
    grid grid-cols-2 w-full gap-4 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
export default InventoryList;
